import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import styles from "./OrderHistory.module.css";
import Order from "../Order/Order";

function OrderHistory() {
  const loggedUser = useSelector((state) => state.user);
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_API_PORT}/user`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${loggedUser.token}`,
          },
        });

        setOrders(response.data.orders);
      } catch (error) {
        console.log(error);
      }
    };
    getUser(); // eslint-disable-next-line
  }, []);

  return (
    orders && (
      <>
        {orders.length > 0 ? (
          <>
            <div className={styles.main + " container"}>
              {orders.map((order, index) => {
                return <Order key={index} order={order} />;
              })}
            </div>
          </>
        ) : (
          <>
            <div className={styles.main + " container text-center"}>
              <h4>¡Aún no tienes ordenes hechas! </h4>
            </div>
          </>
        )}
      </>
    )
  );
}

export default OrderHistory;
